export default {
  home: "/",
  about: "/about",
  signin: "/sign-in",
  forgot: "/forgot",
  verification: "/verification",
  resetpassword: "/reset-password",
  register: "/register", // account type selection screen
  bidderRegister: "/bidder-registration",
  companyRegister: "/company-registration",
  legacySellerRegister: "/seller-register", // redirects to companyRegister
  createvent: "/create-event",
  event: "/event",
  postbidAuction: "/auction/:auction_id/post-bid",
  auction: "/auction",
  organisers: "/organisers", // public organiser directory
  search: "/search/:searchQuery",
  dashboard: "/dashboard",
  profile: "/profile",
  dashboardAuction: "/dashboard/auctions",
  dashBuyer: "/buyer",
  dashSeller: "/seller",
  privacy: "/privacy-policy",
  refundPolicy: "/refund-policy",
  termOfUse: "/term-of-use",
  contactUs: "/contact-us",
  liveAuctions: "/live-auctions",
  apiConfiguration: "/api-configuration", // for admin
  activityLogs: "/activity-logs",
  sellerApiRoute: "/apis", // for seller
  myRequests: "/my-requests", // a bidder's requests to participate
  joinRequests: "/join-requests", // for admin: every request to participate
  confirmEmail: "/confirm-email", // until the email is confirmed, the only page
};
